import {HierarchyNodeType, findLocationEntry} from '@domain/shared'
import {FLEX_PAGE_HEADER_MX, FLEX_PAGE_HEADER_MY} from '@hconnect/common/components'
import {PAGE_HEADER_ML} from '@hconnect/uikit/src/lib2/pageContainer/Page'
import {getPlantName, useUpmPlantsContext} from '@hconnect/upm'
import {Box, SxProps, Theme} from '@mui/material'
import {useMemo} from 'react'
import {useParams} from 'react-router'

import {Breadcrumb, useHierarchyBreadcrumb} from '../../hooks'

import {Breadcrumbs} from './Breadcrumbs'

type PathParameter = {
  plantId?: string
  regionId?: string
  countryId?: string
  areaId?: string
}

type Props<T extends {id: string; name: string; children: T[]}> = {
  sx?: SxProps<Theme>
  hierarchy?: T
}

export const LocationBreadcrumbs = <T extends {id: string; name: string; children: T[]}>({
  sx,
  hierarchy
}: Props<T>) => {
  const upmPlants = useUpmPlantsContext()
  const {areaId, regionId, countryId, plantId} = useParams<PathParameter>()

  const options = useMemo(() => {
    const breadcrumbOptions: Breadcrumb[] = []
    if (areaId) {
      breadcrumbOptions.push({
        name: HierarchyNodeType.Area,
        id: 'areaId',
        label: hierarchy ? findLocationEntry(hierarchy, areaId)?.name || areaId : areaId
      })
    }
    if (regionId) {
      breadcrumbOptions.push({
        name: HierarchyNodeType.Region,
        id: 'regionId',
        label: hierarchy ? findLocationEntry(hierarchy, regionId)?.name || regionId : regionId
      })
    }
    if (countryId) {
      breadcrumbOptions.push({
        name: HierarchyNodeType.Country,
        id: 'countryId',
        label: hierarchy ? findLocationEntry(hierarchy, countryId)?.name || countryId : countryId
      })
    }
    if (plantId) {
      breadcrumbOptions.push({
        name: HierarchyNodeType.Plant,
        id: plantId,
        label: getPlantName(upmPlants, plantId)
      })
    }
    return breadcrumbOptions
  }, [areaId, countryId, hierarchy, plantId, regionId, upmPlants])

  const breadcrumbs = useHierarchyBreadcrumb(options)
  return (
    <Box
      component="span"
      display="flex"
      ml={FLEX_PAGE_HEADER_MX + PAGE_HEADER_ML}
      mt={FLEX_PAGE_HEADER_MY}
      sx={sx}
    >
      <Breadcrumbs breadcrumbs={breadcrumbs} />
    </Box>
  )
}
